import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import Loadable from 'react-loadable';
import Spinner from '../Spinner';
import TicketHome from './Ticket/TicketHome';
import TicketList from './Ticket/TicketList';
import TicketAdd from './Ticket/TicketAdd';

import StatusAdd from './Configuration/Status/StatusAdd';
import ConfigHome from "./Configuration/ConfigHome";
import ReasonAdd from "./Configuration/Reason/ReasonAdd";
import ActionAdd from "./Configuration/Action/ActionAdd";
import StatusEdit from "./Configuration/Status/StatusEdit";
import ReasonEdit from "./Configuration/Reason/ReasonEdit";
import ActionEdit from "./Configuration/Action/ActionEdit";
import ReasonList from "./Configuration/Reason/ReasonList";
import StatusList from "./Configuration/Status/StatusList";
import ActionList from "./Configuration/Action/ActionList";
import WOStatusList from "./Configuration/WorkOrderStatus/WOStatusList";
import WOStatusAdd from "./Configuration/WorkOrderStatus/WOStatusAdd";
import WOStatusEdit from "./Configuration/WorkOrderStatus/WOStatusEdit";
// import MaintenanceHome from './MaintenanceHome';
import PriorityList from "./Configuration/Priority/PriorityList";
import PriorityAdd from "./Configuration/Priority/PriorityAdd";
import PriorityEdit from "./Configuration/Priority/PriorityEdit";
import MaintenanceTypeList from "./Configuration/MaintenanceType/MaintenanceTypeList";
import MaintenanceTypeAdd from "./Configuration/MaintenanceType/MaintenanceTypeAdd";
import MaintenanceTypeEdit from "./Configuration/MaintenanceType/MaintenanceTypeEdit";
import TicketEdit from "./Ticket/TicketEdit";
import TicketView from "./Ticket/TicketView";
import TicketMap from "./Ticket/TicketMap";
import WorkOrderHome from "./WorkOrder/WorkOrderHome";
import WorkOrderMapLeaflet from "./WorkOrder/WorkOrderMapLeaflet";
import WorkOrderRouteMap from "./WorkOrder/WorkOrderRouteMap";
import WorkOrderList from "./WorkOrder/WorkOrderList";
import WorkOrderAdd from "./WorkOrder/WorkOrderAdd";
import WorkOrderEdit from "./WorkOrder/WorkOrderEdit";
import WorkOrderView from "./WorkOrder/WorkOrderView";
import WorkOrderLogRoot from "./WorkOrder/Log/WorkOrderLogRoot";
import WorkOrderTaskList from "./WorkOrder/Task/WorkOrderTaskList";
import WorkOrderTaskAdd from "./WorkOrder/Task/WorkOrderTaskAdd";
import WorkOrderTaskEdit from "./WorkOrder/Task/WorkOrderTaskEdit";
import EmailSetup from "./Configuration/Email/EmailSetup";
import SmtpTest from "./Configuration/Email/SmtpTest";
import { checkRolePermission } from "../../libs/checkPermission";
import TicketWorkOrderAdd from "./Ticket/TicketWorkOrderAdd";
import WorkOrderTicketAdd from "./WorkOrder/WorkOrderTicketAdd";
import WorkOrderStationAdd from "./WorkOrder/WorkOrderStationAdd";
import TicketMapLeaflet from "./Ticket/TicketMapLeaflet";

import SurveyHome from './Survey/SurveyHome';
import SurveyHistory from './Survey/Survey/SurveyHistory';
import SurveyTopicList from './Survey/Topic/SurveyTopicList';
import SurveyTopicModify from './Survey/Topic/SurveyTopicModify';
import SurveyTemplateList from './Survey/SurveyTemplate/SurveyTemplateList';
import SurveyTemplateModify from './Survey/SurveyTemplate/SurveyTemplateModify';
import SurveyCreate from './Survey/Survey/SurveyCreate';
import SurveyView from './Survey/Survey/SurveyView';

import EventHome from "./Event/EventHome";
import EventList from "./Event/EventList";
import EventModify from "./Event/EventModify";
import EventTicketList from "./Event/EventTicketList";

import TripHome from '../Trips/TripHome';
import TripList from '../Trips/TripList';
// import TripMap from '../Trips/TripMap';
import TripAdd from '../Trips/TripAdd';
import TripMapTicketId from '../Trips/TripMapTicketId';
import TripEdit from '../Trips/TripEdit';
import TripStationAdd from '../Trips/TripStationAdd';
// import TripStationEdit from '../Trips/TripStationEdit';

const MaintenanceHome = Loadable({
  loader: () => import('./MaintenanceHome'),
  loading: () => <Spinner />
});

export const MaintenanceRoute = () => (
  <Route component={checkRolePermission(MaintenanceHome)} name={'view maintenance'}>
    <IndexRedirect to='ticket' />
    <Route path='ticket' component={TicketHome}>
      <IndexRedirect to='tabular' />
      <Route path='tabular' component={TicketList}>
        <Route path='add' component={TicketAdd} />
        <Route path=':id' component={TicketEdit} />
        <Route path=':id/view' components={{ ticketView: TicketView }} >
          <Route path='work_order/add' component={TicketWorkOrderAdd} />
        </Route>
      </Route>
      <Route path='map' component={TicketMapLeaflet} />
    </Route>

    <Route path='work_order' component={WorkOrderHome}>
      <IndexRedirect to='tabular' />
      <Route path='tabular' component={WorkOrderList}>
        <Route path='add' component={WorkOrderAdd} />
        <Route path=':id' component={WorkOrderEdit} />
        <Route path=':id/view' components={{ workOrderView: WorkOrderView }}>
          <IndexRedirect to='logs' />
          <Route path='ticket/add' component={WorkOrderTicketAdd} />
          <Route path='station/add' component={WorkOrderStationAdd} />
          <Route path='logs' component={WorkOrderLogRoot} />
          <Route path='tasks' component={WorkOrderTaskList}>
            <Route path='add' component={WorkOrderTaskAdd} />
            <Route path=':task_id' component={WorkOrderTaskEdit} />
          </Route>
        </Route>
      </Route>
      <Route path='map' component={WorkOrderMapLeaflet} />
      <Route path='route' component={WorkOrderRouteMap} />
    </Route>

    <Route >
    <IndexRedirect to='trip' />
    <Route path='trip' component={TripHome}>
      <IndexRedirect to='tabular' />
      <Route path='tabular' component={TripList}>
      <Route path='add' component={TripAdd} />
     
        <Route path=':id' component={TripEdit} />
        {/* <Route path=':id/view' components={{ ticketView: TicketView }} > */}
          <Route path='work_order/add' component={TicketWorkOrderAdd} />
        </Route>
        <Route path='map' component={TripMapTicketId}>
        </Route>
        <Route path='map/:id/view' component={TripMapTicketId}>
        <Route path='stationadd/add/:id' component={TripStationAdd} />
        {/* <Route path='stationadd/add/:id' component={TripStationAdd} /> */}
        </Route>
      </Route>
      {/* <Route path='map' component={TicketMapLeaflet} /> */}
    </Route>

    <Route path='survey' component={SurveyHome}>
      <IndexRedirect to='create' />

      <Route path='create' component={SurveyCreate} >
        <Route path='ticket-create' component={TicketAdd} />
        <Route path='work_order-create' component={WorkOrderAdd} />
      </Route>
      <Route path='history' component={SurveyHistory}>
        <Route path='edit/:id' component={SurveyCreate} />
        <Route path=':id' component={SurveyView} />
      </Route>

      <Route path='template' component={SurveyTemplateList}>
        <Route path=':id' component={SurveyTemplateModify} />
      </Route>

      <Route path='topic' component={SurveyTopicList}>
        <Route path=':id' component={SurveyTopicModify} />
      </Route>

      <Route path='*' component={() => <h2>Work in Progress</h2>} />
    </Route>

    <Route path="event" component={EventHome}>
      <IndexRedirect to="list" />
      <Route path="list" component={EventList}>
        <Route path=":id" component={EventModify} />
      </Route>
      <Route path=":id/ticket" component={EventTicketList} />
    </Route>

    <Route path='config' component={checkRolePermission(ConfigHome)} name={'modify maintenance'}>
      <IndexRedirect to='status' />
      <Route path='status' component={StatusList}>
        <Route path='add' component={StatusAdd} />
        <Route path=':id' component={StatusEdit} />
      </Route>
      <Route path='reason' component={ReasonList}>
        <Route path='add' component={ReasonAdd} />
        <Route path=':id' component={ReasonEdit} />
      </Route>
      <Route path='action' component={ActionList}>
        <Route path='add' component={ActionAdd} />
        <Route path=':id' component={ActionEdit} />
      </Route>

      <Route path='work_order_status' component={WOStatusList}>
        <Route path='add' component={WOStatusAdd} />
        <Route path=':id' component={WOStatusEdit} />
      </Route>
      <Route path='priority' component={PriorityList}>
        <Route path='add' component={PriorityAdd} />
        <Route path=':id' component={PriorityEdit} />
      </Route>
      <Route path='maintenance_type' component={MaintenanceTypeList}>
        <Route path='add' component={MaintenanceTypeAdd} />
        <Route path=':id' component={MaintenanceTypeEdit} />
      </Route>
      <Route path='email' component={EmailSetup}>
        <Route path='test' component={SmtpTest} />
      </Route>
    </Route>

  </Route>
);


// WEBPACK FOOTER //
// ./src/components/Maintenance/routes.js